var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBurger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.6,
    y: 0.6,
    width: 38.8,
    height: 38.8,
    rx: 19.4,
    transform: "matrix(-1 0 0 1 38.8 0)",
    stroke: "#B3B3B3",
    strokeOpacity: 0.31,
    strokeWidth: 1.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 20C29 20.1989 28.921 20.3897 28.7803 20.5303C28.6397 20.671 28.4489 20.75 28.25 20.75H11.75C11.5511 20.75 11.3603 20.671 11.2197 20.5303C11.079 20.3897 11 20.1989 11 20C11 19.8011 11.079 19.6103 11.2197 19.4697C11.3603 19.329 11.5511 19.25 11.75 19.25H28.25C28.4489 19.25 28.6397 19.329 28.7803 19.4697C28.921 19.6103 29 19.8011 29 20ZM11.75 14.75H28.25C28.4489 14.75 28.6397 14.671 28.7803 14.5303C28.921 14.3897 29 14.1989 29 14C29 13.8011 28.921 13.6103 28.7803 13.4697C28.6397 13.329 28.4489 13.25 28.25 13.25H11.75C11.5511 13.25 11.3603 13.329 11.2197 13.4697C11.079 13.6103 11 13.8011 11 14C11 14.1989 11.079 14.3897 11.2197 14.5303C11.3603 14.671 11.5511 14.75 11.75 14.75ZM21.25 25.25H11.75C11.5511 25.25 11.3603 25.329 11.2197 25.4697C11.079 25.6103 11 25.8011 11 26C11 26.1989 11.079 26.3897 11.2197 26.5303C11.3603 26.671 11.5511 26.75 11.75 26.75H21.25C21.4489 26.75 21.6397 26.671 21.7803 26.5303C21.921 26.3897 22 26.1989 22 26C22 25.8011 21.921 25.6103 21.7803 25.4697C21.6397 25.329 21.4489 25.25 21.25 25.25Z",
    fill: "black",
    fillOpacity: 0.24
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurger);
export default __webpack_public_path__ + "static/media/burger.3cebf7005fa6a64b798193e78e3613ec.svg";
export { ForwardRef as ReactComponent };